import React from 'react';
import './LandingPage.css';

const LandingPage = ({ onUserLogin, onAdminLogin }) => {
  return (
    <div className="landing-container">
      <div className="landing-card">
        <div className="landing-header">
          <h1>🔗 IoT Device Registry</h1>
          <p>Hyperledger Fabric Blockchain Management System</p>
        </div>

        <div className="landing-content">
          <div className="welcome-section">
            <h2>Welcome to IoT Device Registry</h2>
            <p>Manage your IoT devices securely on the blockchain</p>
          </div>

          <div className="auth-options">
            <div className="auth-option">
              <div className="auth-icon">👤</div>
              <h3>User Access</h3>
              <p>Register or login to manage your IoT devices</p>
              <button 
                className="auth-btn user-btn"
                onClick={onUserLogin}
              >
                👤 User Login / Register
              </button>
            </div>

            <div className="auth-divider">
              <span>or</span>
            </div>

            <div className="auth-option">
              <div className="auth-icon">🔐</div>
              <h3>Admin Access</h3>
              <p>Administrative access for user management</p>
              <button 
                className="auth-btn admin-btn"
                onClick={onAdminLogin}
              >
                🔐 Admin Login
              </button>
            </div>
          </div>

          <div className="features-section">
            <h3>Features</h3>
            <div className="features-grid">
              <div className="feature">
                <span className="feature-icon">🔐</span>
                <span>Secure Authentication</span>
              </div>
              <div className="feature">
                <span className="feature-icon">📱</span>
                <span>Device Management</span>
              </div>
              <div className="feature">
                <span className="feature-icon">⛓️</span>
                <span>Blockchain Security</span>
              </div>
              <div className="feature">
                <span className="feature-icon">🔒</span>
                <span>Data Encryption</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage; 